import { render } from "./JFCLayout.vue?vue&type=template&id=c0b9c4ce&scoped=true"
import script from "./JFCLayout.vue?vue&type=script&lang=js"
export * from "./JFCLayout.vue?vue&type=script&lang=js"

import "./JFCLayout.vue?vue&type=style&index=0&id=c0b9c4ce&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0b9c4ce"],['__file',"src/scripts/view/jobFitChecker/JFCLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c0b9c4ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c0b9c4ce', __exports__)) {
    api.reload('c0b9c4ce', __exports__)
  }
  
  module.hot.accept("./JFCLayout.vue?vue&type=template&id=c0b9c4ce&scoped=true", () => {
    api.rerender('c0b9c4ce', render)
  })

}


export default __exports__